<template>
  <div class="circulateView">
    <div class="circulateT">
        <img class="image" src="./img/titleA.png" alt="">
    </div>
    <div class="circulate">
        <img class="image" src="./img/titleB.png" alt="">
    </div>
    <div class="circulateB circulateTitle">
        <img class="image" src="./img/titleC.png" alt="">
    </div>
    <div class="circulateB circulateTitle">
        <img class="image" src="./img/titleD.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'circulateView'
}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.circulateTitle{
   padding-left: 22px/$md;
   padding-right: 22px/$md;
}
.circulate{
    width: 250px/$md;
    height: 107px/$md;
    margin: 50px/$md auto;
}
.circulateB{
    margin-bottom: 50px/$md;
}
.image{
    width:100%;
    height: 100%;
}
</style>
